import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button, Select } from 'components'
import styles from './index.module.css'
import carImg1 from 'images/tmp_fincar_image01.png'
import carImg2 from 'images/tmp_fincar_image02.png'
import carImg4 from 'images/tmp_fincar_image04.png'

const FincarPopular = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="padding">
				<h3><span className="text-blue">30대 남성</span> <span>인기 차량</span></h3>
				<div className={`${styles["select-group"]} mt_30`}>
					<Select className="box" title="소득 금액 선택" placeholder="금액추가" selected={0} data={[
						{ key: "2,400만원 미만", value: 0 },
						{ key: "2,400만원 ~ 3,000만원 미만", value: 1 },
						{ key: "3,000만원 ~ 5,000만원 미만", value: 2 },
						{ key: "5,000만원 ~ 7,000만원 미만", value: 3 },
						{ key: "7,000만원 ~ 1억원 미만", value: 4 },
						{ key: "1억원 이상", value: 5 },
					]} onSelect={(key, value) => {
						console.log(key, value)
					}}>
					</Select>
					<Select className="box ml_10" title="가족 수(탑승인원) 선택" placeholder="인원추가" selected={0} data={[
						{ key: "1명", value: 0 },
						{ key: "2명", value: 1 },
						{ key: "3명 ~ 4명", value: 2 },
						{ key: "5명 ~ 6명", value: 3 },
						{ key: "7명 이상", value: 4 },
					]} onSelect={(key, value) => {
						console.log(key, value)
					}}>
					</Select>
				</div>

				<div className={`${styles["pop-rank"]} mt_30`}>
					<div>
						<div className={styles["rank-tit"]}>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_gold`} />
								<strong className="ml_10">기아 EV6</strong>
							</div>
							<div className={styles.price}>
								<strong>4,500만원 ~ 6,750만원</strong>
							</div>
						</div>
						<ul className={`${styles["car-list"]} ${styles["type-list"]} list-bg mt_10`}>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg1} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg1} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div>
						<div className={styles["rank-tit"]}>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_silver`} />
								<strong className="ml_10">현대 싼타페</strong>
							</div>
							<div className={styles.price}>
								<strong>3,150만원 ~ 4,350만원</strong>
							</div>
						</div>
						<ul className={`${styles["car-list"]} ${styles["type-list"]} list-bg mt_10`}>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg4} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>현대 싼타페 더 프라임 디젤 2.0 2WD 5인승</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg4} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>현대 싼타페 더 프라임 디젤 2.0 2WD 5인승</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg4} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>현대 싼타페 더 프라임 디젤 2.0 2WD 5인승</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
						</ul>
						{/* 3개 이상의 리스트에서만 더보기 버튼 노출 */}
						<Button className="btn btn--big btn-more mt_20">+ 더보기</Button>
					</div>
					<div>
						<div className={styles["rank-tit"]}>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_bronze`} />
								<strong className="ml_10">기아 K9</strong>
							</div>
							<div className={styles.price}>
								<strong>6,500만원 ~ 1억 200만원</strong>
							</div>
						</div>
						<ul className={`${styles["car-list"]} ${styles["type-list"]} list-bg mt_10`}>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg2} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘Ⅰ</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg2} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘Ⅰ</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
							<li>
								<div className={styles.info}>
									<div className={`${styles["car-img"]} img-box`}>
										<img src={carImg2} alt="" />
									</div>
									<div className={`${styles.txt} ml_20`}>
										<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘Ⅰ</div>
										<span>21년식 67,000km</span>
										<div className={styles.price}>
											<strong>6,500</strong> 만원
										</div>
									</div>
								</div>
							</li>
						</ul>
						{/* 3개 이상의 리스트에서만 더보기 버튼 노출 */}
						<Button className="btn btn--big btn-more mt_20">+ 더보기</Button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default FincarPopular